export default {
  data: null,
  error: null,
  loading: false,
  doctorsFilter: []
}
